"use client";

import React from "react";
import { Stack, Text, Button, Link, Tooltip } from "@chakra-ui/react";
import { FcLock } from "react-icons/fc";
import { VscPreview } from "react-icons/vsc";
import { FaExternalLinkAlt } from "react-icons/fa";
import { CiBookmark } from "react-icons/ci";
import { MdFavoriteBorder } from "react-icons/md";

type Props = {
  header: any;
  linkVal: any;
  setLink: any;
  setLoading?: any;
};
export default function LinkListCard({
  header,
  linkVal,
  setLink,
  setLoading,
}: Props) {
  return (
    <Stack
      bg={"gray.50"}
      w="full"
      p="4"
      boxShadow="lg"
      my="2"
      borderRadius="xl"
    >
      <Stack direction="row" alignItems="center">
        <Text fontWeight="semibold">{header}</Text>
      </Stack>

      <Stack
        direction={{ base: "column", md: "row" }}
        justifyContent="space-between"
      >
        <Text
          isTruncated
          maxWidth={20}
          fontSize={{ base: "sm" }}
          textAlign={"left"}
          maxW={"4xl"}
        >
          {linkVal}
        </Text>
      </Stack>
      <Text
        isTruncated
        maxWidth={20}
        fontSize={{ base: "sm" }}
        textAlign={"left"}
        maxW={"4xl"}
      >
        Link Based description comes here
      </Text>
      {linkVal && (
        <Stack direction={{ base: "column", md: "row" }}>
          <Button
            onClick={() => {
              setLoading(true);
              setLink("https://todo-chrome-be.fly.dev/proxy?url=" + linkVal);
            }}
            variant="outline"
            colorScheme="green"
          >
            <VscPreview size={15} />
          </Button>
          <Button
            variant="outline"
            as={Link}
            href={linkVal}
            colorScheme="green"
            isExternal
          >
            <FaExternalLinkAlt size={15} />
          </Button>
          <Tooltip content="Save">
            <Button
              variant="outline"
              // as={Link}
              // href={linkVal}
              colorScheme="green"
            >
              <CiBookmark size={15} />
            </Button>
          </Tooltip>
          <Button
            variant="outline"
            // as={Link}
            // href={linkVal}
            colorScheme="green"
          >
            <MdFavoriteBorder size={15} />
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
